import { useState, useEffect, useContext } from "react"
import { authContext } from "../context/AuthContext"
import axios from "axios"
import api from "./axiosInterceptor.js"

axios.defaults.withCredentials = true
const baseUrl = process.env.REACT_APP_NETLIFY_API_URL || process.env.REACT_APP_API_URL //ENV VARIABLE WITH THE DEFAULT URL 


export default function FetchData(url, reload, updateReload) {
    console.log('in fetch')
    const { changeAuth } = useContext(authContext)

    // const tkn = sessionStorage.getItem("urtkn")

    const [data, setData] = useState(null)
    const [error, setError] = useState(null)
    const [load, setLoad] = useState(true)


    useEffect(() => {

        async function getData() {

            try {
                setLoad(true)
                const response = await api.get(`api/${url}`)
                if (response.status === 200) {
                    setData(response.data)
                } else if (response.status === 401) {
                    setData(false)
                    changeAuth(false)
                }
                else {
                    setData(false)
                    throw response
                }

            } catch (err) {
                setData(false)
                setError(err)
            } finally {
                updateReload(false)
                setLoad(false)
            }
        }
        if (reload) {
            getData()
        }
    }, [url, reload])
    return { data, error, load }
}